import { Context } from "./types"

export const getGetRequestParams = (ctx: Context) => ({
  orgFilter: {
    ...ctx.orgFilter
  },
  propertySorters: ctx.sort ? [ctx.sort] : undefined,
  propertyFilters: Object.entries(ctx.propertyFilter ?? {})
    .filter(([_, values]) => values.length > 0)
    .map(([name, values]) => ({ name, values })),
  searchTerm: ctx.search
})

export const getPaginationParams = (ctx: Context) => ({
  page: ctx.page,
  pageSize: ctx.pageSize
})
